import { GridColumnsManagement, GridColumnsManagementProps } from "@mui/x-data-grid";

export default function CustomGridColumnsManagement(props: GridColumnsManagementProps) {
  // const apiRef = useGridApiContext();
  // const preferencePanelState = useGridSelector(apiRef, gridColumns);

  // console.log("CustomGridColumnsManagement", props, {
  //   getAllColumns: apiRef.current.getAllColumns(),
  //   getVisibleColumns: apiRef.current.getVisibleColumns(),
  //   togglableColumns: props.getTogglableColumns?.(apiRef.current.getAllColumns()),
  // });

  return <GridColumnsManagement {...props} />;
}
